/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const YoutubeCircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    viewBox="0 0 40 40"
    {...props}
    data-palette="YoutubeCircleIcon">
    <g fill="none" fillRule="nonzero">
      <circle cx={19.858} cy={19.858} r={19.858} fill="#212933" />
      <path
        fill="#FFF"
        d="m29.558 14.212.025.179c-.242-.938-.895-1.66-1.724-1.924l-.017-.004C26.282 12 20.008 12 20.008 12s-6.258-.01-7.833.463c-.845.267-1.498.99-1.736 1.908l-.004.02c-.582 3.324-.586 7.32.026 10.88l-.026-.18c.242.936.894 1.66 1.724 1.922l.017.005c1.558.463 7.833.463 7.833.463s6.258 0 7.834-.463c.845-.268 1.499-.99 1.736-1.909l.004-.019c.265-1.546.417-3.326.417-5.143V19.535c0-1.818-.152-3.597-.442-5.323Zm-11.551 8.854v-6.642l5.221 3.326-5.221 3.316Z"
      />
    </g>
  </svg>
);

export default YoutubeCircleIcon;
